import createSvgIcon from '@mui/material/utils/createSvgIcon.js';
import React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    d="m2.7607 2.8393 18.3847 18.3848-1.0606 1.0607L18.7 20.9H5.2607c-1.05 0-1.9178-.82-1.9945-1.8513L3.2607 18.9 3.26 5.46 1.7 3.9zM8.937 11.137 5.24 7.44l.0007 11.46H16.7l-3.678-3.678-.7613 1.678-1.5625-3.4375L7.2607 11.9zm12.3237-.237v6.379l-2-2V10.9zm-6.529-.15 2.529 1.15-.948.431zm3.529-8.85 1.2533 2.7467L22.2607 5.9 19.514 7.1533 18.2607 9.9l-1.2534-2.7467L14.2607 5.9l2.7466-1.2533zm-6 5 1.149 2.528-1.58-1.58zm.98-4v2h-4.359l-2-2z"
  />,
  'NoEnhance',
);
